// client/src/components/common/SearchBar.js
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// CSS loaded at page level - removed duplicate import

const SearchBar = ({
    onSearch,
    searchTerm: externalSearchTerm = "",
    placeholder,
    onReset,
    isSticky = false,
}) => {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState(externalSearchTerm);

    // Sync with external search term (when parent resets)
    useEffect(() => {
        setSearchTerm(externalSearchTerm);
    }, [externalSearchTerm]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch(searchTerm);
    };

    const handleChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleClear = () => {
        setSearchTerm("");
        onSearch("");
        if (onReset) onReset();
    };

    return (
        <form
            className={`search-bar ${isSticky ? "search-bar-sticky" : ""}`}
            onSubmit={handleSubmit}
            role="search"
            aria-label={t('search.button')}
        >
            {/* Visually hidden label for accessibility and autofill */}
            <label htmlFor="site-search" className="sr-only">
                {t('search.placeholder')}
            </label>
            <div className="search-input-wrapper">
                <input
                    type="search"
                    id="site-search"
                    name="q"
                    value={searchTerm}
                    onChange={handleChange}
                    placeholder={placeholder || t('search.placeholder')}
                    aria-label={placeholder || t('search.placeholder')}
                    className="search-input"
                />

                {/* Show clear button if there's text */}
                {searchTerm && (
                    <button
                        type="button"
                        onClick={handleClear}
                        className="clear-button"
                        title={t('search.clear')}
                        aria-label={t('search.clear')}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            width="1em"
                            height="1em"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="15" y1="9" x2="9" y2="15" />
                            <line x1="9" y1="9" x2="15" y2="15" />
                        </svg>
                    </button>
                )}
            </div>

            <button type="submit" className="search-button" aria-label={t('search.button')}>
                <span className="search-icon" aria-hidden="true">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        width="1em"
                        height="1em"
                        focusable="false"
                    >
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                </span>
                <span className="search-text">{t('search.button')}</span>
            </button>
        </form>
    );
};

export default SearchBar;
